import React from 'react'
import styles from './styles.css'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'

export default function VehicleTag(props) {
  const {vehicle, onClick} = props

  return (
    <div
      onClick={onClick}
      className={styles[!vehicle.approvedAt ? 'notApproved' : vehicle.categoryId]}>
      <Tooltip
        content={
          !vehicle.approvedAt
            ? `${vehicle.firstName} ${vehicle.lastName} - No aprobado`
            : `${vehicle.firstName} ${vehicle.lastName} - ${vehicle.completedOrdersCount} viajes`
        }>
        #{vehicle.code} {vehicle.firstName}
      </Tooltip>
    </div>
  )
}
